
var jquery = require('jquery/dist/jquery.min.js');

class Ajax {

  constructor () {
  }

  jsonp (url, params) {
    this.req(url, Object.assign({jsonp: 'callback', dataType: 'jsonp'}, params))
  }

  textp (url, params) {
    this.req(url, Object.assign({jsonp: 'callback', crossDomain: true, dataType: 'text'}, params))
  }

  json (url, params) {
    this.req(url, Object.assign({dataType: 'json'}, params))
  }

  text (url, params) {
    this.req(url, Object.assign({dataType: 'text'}, params))
  }

  myLoadMethod() {
    console.log('ok loaded', arguments)
  }

  manualScriptingReq(url, params) {
    var head  = document.getElementsByTagName('head')[0];
    var scr   = document.getElementById('manual-scripting') || document.createElement('script');

    scr.id = 'manual-scripting';
  //  scr.type = 'text/plain';
    scr.onload = this.myLoadMethod();

    var query = [];
    for (var key in params.data) {
      query.push(key + "=" + params.data[key]);
    }

    scr.src = url + "?" + query.join("&");
    head.appendChild(scr);
  }

  iframeScriptingReq(url, params) {
    var scr   = this.iframeElement = this.iframeElement || document.createElement('iframe');

    scr.id = 'iframe-manual-scripting';
    scr.type = 'text/plain';
    scr.width = 500 * 2;
    scr.style.float = 'left';
    scr.style.WebkitTransform = 'scale(0.5)';
    scr.style.marginTop = -205;
    scr.height = 400 * 2;
    scr.style.position = "absolute";
    scr.style.left = 500;
    scr.style.top = 200;
    scr.onload = this.myLoadMethod();


    var query = [];
    for (var key in params.data) {
      query.push(key + "=" + params.data[key]);
    }

    scr.src = url + "?" + query.join("&");

    document.body.appendChild(scr);
  }


  req (url, params) {
    if (params.manualScripting) {
      //this.manualScriptingReq(url, params);
      this.iframeScriptingReq(url, params);
    } else {
      jquery.ajax(url, params)
    }
  }

  promise(url, params) {
    var Me = this;
    return new Promise(function (resolve, reject) {
      params.success = (...args) => {
        resolve(...args);
      }

      params.error = (...args) => {
        reject(...args);
      }

      Me.req(url, params);
    })
  }

  promise_text(url, params) {
    return this.promise(url, Object.assign({dataType: 'text'}, params))
  }


  promise_json(url, params) {
    return this.promise(url, Object.assign({dataType: 'json'}, params))
  }

  promise_jsonp(url, params) {
    return this.promise(url, Object.assign({dataType: 'jsonp'}, params))
  }

  window_open(url, params) {
    console.log('opening window: ', url + "?" + require('querystring').stringify(params.data))
    return new Promise(function (resolve, reject) {
      params.success = (...args) => {
        resolve(...args);
      }

      params.error = (...args) => {
        reject(...args);
      }

      try {
        window.open(url + "?" + require('querystring').stringify(params.data));
        resolve();
      } catch(err) {
        reject();
      }
    })
  }

  download(filename, text) {
      var pom = document.createElement('a');
      pom.setAttribute('href', 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(text));
      pom.setAttribute('download', filename);

      if (document.createEvent) {
          var event = document.createEvent('MouseEvents');
          event.initEvent('click', true, true);
          pom.dispatchEvent(event);
      }
      else {
          pom.click();
      }
  }

}

export default Ajax;



// WEBPACK FOOTER //
// ./app/react/data/Ajax.jsx